<template>
    <div class="ai-close-button" @click="onClick">
        <svg class="ai-close-button-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                :stroke-width="buttonData.strokeWidth"
                d="M368 368L144 144M368 144L144 368"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'close-button',
};
</script>

<script setup>
import { ref, defineEmits, computed } from 'vue';
const buttonState = ref('out');
const emit = defineEmits(['click']);

const buttonData = computed(() => {
    if (buttonState.value === 'out') {
        return {
            style: 'width: 21px; height: 21px;',
            backFill: 'none',
            stroke: '#000',
            strokeWidth: 12,
        };
    }
    return {
        style: 'width: 21px; height: 21px;  border-style: solid; border-width: 2px; border-color: #f1e8e8;',
        backFill: '#fc6e41',
        stroke: '#ffffff',
        strokeWidth: 37,
    };
});

// const onMouseOver = () => {
//     buttonState.value = 'over';
// };
//
// const onMouseOut = () => {
//     buttonState.value = 'out';
// };

const onClick = e => {
    emit('click', e);
};
</script>

<style scoped></style>
